import { LoadingComponent } from '@pages/layout/components/loading/loading.component';
import { Injectable, TemplateRef, Type, ViewContainerRef } from '@angular/core';

import { NzModalRef, NzModalService, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private modal: NzModalService) {}

  create(NzModalCustomComponent: any, data: Object = {}, width: string = '500px') {
    this.modal.closeAll();

    const modal = this.modal.create({
      nzContent: NzModalCustomComponent,
      nzData: data,
      nzClosable: false,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzKeyboard: false,
      nzWidth: width
    });

    return modal;
  }

  loadingModal() {
    this.modal.closeAll();

    const modal = this.modal.create({
      nzContent: LoadingComponent,
      nzClosable: false,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzKeyboard: false,
      nzWidth: '400px',
      nzClassName: 'loading-modal',
    });

    return modal;
  }
}
